<div class="container salecomponent" style="width:500px !important;">
  <div class="form-footer">
    <div *ngIf="message != ''" class="form-control field-xl msg" style="margin-left:10px;" [ngClass]="status == 1 ? 'alert-success' : 'alert-danger'">
      {{message}}
    </div>
    <div class="controlsBar">
      <input type="button" id="btnSave" class="btn btn-primary mr-10" value="Save" (click)="onSave();" [disabled]="!hasValidFollowup()" />

    </div>
  </div>

  <div class="clearfix input-section followup-section h190">
    <div class="col-md-12 w-100" *ngIf="selectedMember.Reminders?.length == 0 || ( selectedMember.Reminders[0].ReminderDateTime < currentDate)">
      <!--*ngIf="incompleteReminders == 0 || selectedMember.Reminders.length == 0"-->
      <reminder-control [DisplayMode]="ReminderDisplayMode.Text"
                        [CompactView]="true"
                        [selectedData]="newFollowup"
                        [(ngModel)]="newFollowup"
                        SubTypeLabel="Followup Reason"
                        ResponseTypeLabel="Feedback"
                        DisableSubType="false"
                        DisableResponseType="false"
                        [SubTypeList]="SubTypeList"
                        [ResponseTypeList]="ResponseTypeList">
      </reminder-control>
    </div>
    <div class="col-md-12 w-100" *ngIf="selectedMember.Reminders?.length > 0">
      <table class="w-100">
        <tr *ngFor="let reminder of selectedMember.Reminders; let i = index">
          <td *ngIf="i==0">
            <reminder-control [DisplayMode]="ReminderDisplayMode.Text"
                              [CompactView]="true"
                              [ForceEnable]="isPartialAdminUser"
                              placeholderText=""
                              [selectedData]="selectedMember.Reminders[i]"
                              [(ngModel)]="selectedMember.Reminders[i]"
                              SubTypeLabel="Followup Reason"
                              ResponseTypeLabel="Feedback"
                              DisableSubType="true"
                              DisableResponseType="true"
                              [SubTypeList]="SubTypeList"
                              [ResponseTypeList]="ResponseTypeList"
                              [isDisabled]="selectedMember.Reminders[0].ReminderDateTime < currentDate"
                              >
            </reminder-control>
          </td>
          <td *ngIf="i!=0">
            <reminder-control [DisplayMode]="ReminderDisplayMode.Text"
                              [CompactView]="true"
                              placeholderText=""
                              [selectedData]="selectedMember.Reminders[i]"
                              [(ngModel)]="selectedMember.Reminders[i]"
                              SubTypeLabel="Followup Reason"
                              ResponseTypeLabel="Feedback"
                              DisableSubType="true"
                              DisableResponseType="true"
                              [SubTypeList]="SubTypeList"
                              [ResponseTypeList]="ResponseTypeList"
                              [isDisabled]="selectedMember.Reminders[0].ReminderDateTime < currentDate"
                              >
            </reminder-control>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <!--User Info-->
  <div class="clearfix input-section">
    <div class="sub-section-45 personal-info" style="padding:0;">
      <div class="clearfix">
        <div class="profile-pic fl xs compact-field">
          <img [src]="profileImageUrl" alt="profile" />
        </div>
        <div class="title compact-field labelvalue"> <span> {{selectedMember.Salutation}} {{selectedMember.FirstName}} {{selectedMember.LastName}} </span></div>
        <div class="sub-title compact-field">Occupation: <span>{{selectedMember.Occupation}}</span> </div>
        <div class="fieldname compact-field">Reg ID:<span class="fieldvalue compact-field"> {{selectedMember.IdentityId}}</span></div>
      </div>

    </div>
    <div class="sub-section-45-clean membership-info">
      <div class="clearfix line-compact">
        <span class="fieldname compact-field"> User Name: </span> <span class="fieldvalue compact-field"> {{selectedMember.UserName}}</span>
      </div>
      <div class="clearfix line-compact">
        <span class="fieldname compact-field">Contact:</span> <span class="fieldvalue compact-field"> {{selectedMember.Contact1}} {{selectedMember.Contact2 ?"/ "+selectedMember.Contact2 : ""}}</span>
      </div>
      <div class="clearfix line-compact">
        <span class="fieldname compact-field">Email:</span> <span class="fieldvalue compact-field"> {{selectedMember.Email}}</span>
      </div>
      <div class="clearfix line-compact">
        <span class="fieldname compact-field">Date of Birth: </span> <span class="fieldvalue compact-field"> {{selectedMember.DateOfBirth?.toLocaleDateString('en-GB')}}</span>
      </div>
      <div class="clearfix line-compact">
        <span class="fieldname compact-field"> Referred By:</span> <span class="fieldvalue compact-field"> {{selectedMember.ReferredBy?.FirstName}} {{selectedMember.ReferredBy?.LastName}} </span>
      </div>
      <div class="clearfix line-compact">
        <span class="fieldname compact-field"> Attended By:</span> <span class="fieldvalue compact-field">{{selectedMember.EnrolledBy?.FirstName}} {{selectedMember.EnrolledBy?.LastName}} </span>
      </div>
      <div class="clearfix line-compact">
        <span class="fieldname compact-field"> Priority:</span> <span class="fieldvalue compact-field"> {{selectedMember.Stage?.Name}} </span>
      </div>
    </div>
  </div>

  <!--Package Section-->
  <div class="clearfix hide">
    <div class="col-md-12">
      <table class="table table-bordered table-hover table-readonly-data compact-table grey" id="tab_logic">
        <thead>
          <tr>
            <th class="text-center hide">Sr.</th>
            <th class="text-center"> Package Name </th>
            <th class="text-center"> Duration</th>
            <th class="text-center"> Price </th>
            <th class="text-center"> Discount </th>
            <th class="text-center"> Start Date </th>
            <th class="text-center"> Consultant </th>
            <th class="text-center hide">  </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let um of selectedMember.UserMemberships; let i = index">
            <td class="hide">
              {{i+1}}
              <input type="hidden" [(ngModel)]="um.UserMembershipPlanId" />
            </td>
            <td>
              <mat-form-field class="form-element field-m">
                <input matInput type="text" placeholder="" [ngModel]="um.Name" [disabled]="true">
              </mat-form-field>
            </td>
            <td>
              <mat-form-field class="form-element field-xs">
                <input matInput type="number" placeholder="" [ngModel]="um.PlanDurationDays" [disabled]="true">
              </mat-form-field>
            </td>
            <td>
              <mat-form-field class="form-element field-xs">
                <input matInput type="number" placeholder="" [ngModel]="um.Price" [disabled]="true">
              </mat-form-field>
            </td>
            <td>
              <mat-form-field class="form-element field-xs" style="width:24px;margin-right:3px;">
                <input matInput type="number" placeholder="%" value="15" (change)="um.DiscountPerc == 0 ? um.DiscountAmt = 0 : um.DiscountAmt = um.DiscountAmt" [(ngModel)]="um.DiscountPerc" [disabled]="true">
              </mat-form-field>
              <mat-form-field class="form-element field-xs " style="width:24px;">
                <input matInput type="number" placeholder="Amt." value="50" [(ngModel)]="um.DiscountAmt" [disabled]="true">
              </mat-form-field>
            </td>
            <td>
              <mat-form-field class="form-element field-s">
                <input matInput [matDatepicker]="psdpicker" [(ngModel)]="um.PlanStartDate" [disabled]="true">
                <mat-datepicker #psdpicker></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <div class="form-element field-l">
                <popup-search *ngIf="um.Name!='Admission Fee' || um.Name!='Registration Charges'" [isDisabled]="true" style="width: 80px; display: block; float: left; margin-right: 5px;" [DisplayMode]="EnumDisplayMode.AutoComplete" [placeholderText]="'Trainer'" [dataFor]="EnumDataFor.Trainer" [GetDataAsEntity]="true" [required]="false" [(ngModel)]="um.Consultant"></popup-search>
                <mat-form-field *ngIf="isAdminUser && um.IsPersonalized" class="form-element field-xs" style="width: 30px; margin: 0 0 0 5px;">
                  <input matInput type="number" placeholder="Inc. %" [(ngModel)]="um.CommissionPerc" [disabled]="true">
                </mat-form-field>
              </div>
            </td>
            <td style="width:30px;" class="hide">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>






  <div class="overlay-progress" *ngIf="showProgress==true">

  </div>

  <style type="text/css">
    .nsm-content {
      width: 770px !important;
    }
  </style>
</div>
